import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-card-details-with-schedules-delete-dialog',
    template: require('./cardDetailsWithSchedulesDialogDelete.html')
})
export class CardDetailsWithSchedulesDeleteDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<CardDetailsWithSchedulesDeleteDialog>) public dialogRef: MatDialogRef<CardDetailsWithSchedulesDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
